const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { chat: chatApi } = require('@doctoroncallcom/api')
const {
  POST_CHAT_DATA,
  GET_CHAT_DATA,
} = require('./constants')

const {
  postChatDataSuccess,
  postChatDataError,
  getChatDataSuccess,
  getChatDataError,
} = require('./actions')

const postChatDataEpic = (action$, state$, { api }) => action$.pipe(
  ofType(POST_CHAT_DATA),
  mergeMap(action => chatApi.postChatDataApi(api, action.payload.data, action.payload.id)
    .then(response => postChatDataSuccess(response.data))
    .catch(error => postChatDataError(error))),
)

const getChatDataEpic = (action$, state$, { api }) => action$.pipe(
  ofType(GET_CHAT_DATA),
  mergeMap(action => chatApi.getChatDataApi(api, action.payload.id)
    .then(response => getChatDataSuccess(response.data))
    .catch(error => getChatDataError(error))),
)

module.exports = {
  postChatDataEpic,
  getChatDataEpic,
}
